import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateClef } from "../api/CLEF/clef";

export function useUpdateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateClef(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
}
